<template>
  <div>
    <Form
      page-title="Add a new User"
      buttonName="Submit"
      :businessId="businessId"
      :isCreateMode="true"
      :isInList="isInList"
      @submit="submit"
      ref="menusForm"
      :loading="loading"
    />
  </div>
</template>
<script>
import Form from "./Form";
import { submitAndNotify } from "@/helpers/utils";
import { createUser } from "@/API/UsersAPIs";
export default {
  name: "Create",
  props: ["isInList", "businessId"],
  components: { Form },
  data() {
    return {
      loading: false
    };
  },

  methods: {
    async submit(formData) {
      const callback = () => {
        this.$refs.menusForm.resetForm();
      };
      submitAndNotify(this, createUser(formData), callback);
    }
  }
};
</script>
<style></style>
